import { BillingDataPeriod } from 'reactApp/api/billing/data/BillingDataAPICall.types';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import type { Product } from 'reactApp/types/Billing';

export function getCurrentSubscriptionPeriod(subs: BillingDataSubscriptionInfo, currentPeriod?: BillingDataPeriod) {
    switch (currentPeriod) {
        case BillingDataPeriod.DISCOUNT:
            return subs.productDiscountPeriod!;
        case BillingDataPeriod.TRIAL:
            return subs.productTrialPeriod!;
        case BillingDataPeriod.REGULAR:
        default:
            return subs.productPeriod!;
    }
}

export function getCurrentProductPeriod(product: Product, currentPeriod?: BillingDataPeriod) {
    switch (currentPeriod) {
        case BillingDataPeriod.DISCOUNT:
            return product.discountPeriod!;
        case BillingDataPeriod.TRIAL:
            return product.trialPeriod!;
        case BillingDataPeriod.REGULAR:
        default:
            return product.period;
    }
}

export function getCurrentProductPrice(product: Product, currentPeriod?: BillingDataPeriod) {
    switch (currentPeriod) {
        case BillingDataPeriod.DISCOUNT:
            return product.discountPrice!;
        case BillingDataPeriod.TRIAL:
            return 1;
        case BillingDataPeriod.REGULAR:
        default:
            return product.price;
    }
}
